import React, { FC } from "react";
import { User, Maybe } from "api";
import { Typography } from "@mui/material";
import BlueTick from "components/BlueTick";
import GreenTick from "components/GreenTick";
import YellowTick from "./YellowTick";

const Name: FC<{ user: Maybe<User> | undefined }> = ({ user }) => (
    <Typography variant="subtitle2">
        {`${user?.firstName} ${user?.lastName}`}
        {Boolean(user?.isVerified) && <BlueTick />}
        {Boolean(user?.greenTick) && <GreenTick />}
        {Boolean(user?.tick3) && <YellowTick />}
    </Typography>
)

export default Name;